import PropTypes from 'prop-types';
import track from 'react-tracking';
import { useTranslation } from 'react-i18next';

import AlertIcon from 'components/svg/AlertIcon';
import SimpleButton from 'components/shared/SimpleButton';

import {
  AlertIconWrapper,
  CTAWrapper,
  ErrorText,
  ErrorViewWrapper,
} from './style';

const ErrorView = ({
  hasBackground,
  onRetryClick,
  text,
}) => {
  const { t } = useTranslation(['common', 'errors']);

  return (
    <ErrorViewWrapper hasBackground={hasBackground}>
      <AlertIconWrapper>
        <AlertIcon variant="yellow" />
      </AlertIconWrapper>
      <ErrorText>{text || t('errors:defaultErrorMessage')}</ErrorText>
      {onRetryClick && (
        <CTAWrapper>
          <SimpleButton onClick={onRetryClick} variant="white">
            {t('tryAgain')}
          </SimpleButton>
        </CTAWrapper>
      )}
    </ErrorViewWrapper>
  );
};

ErrorView.propTypes = {
  hasBackground: PropTypes.bool,
  onRetryClick: PropTypes.func,
  text: PropTypes.string,
};

ErrorView.defaultProps = {
  hasBackground: false,
  onRetryClick: null,
  text: null,
};

export default track(({ text }) => ({ errorMessage: text }), {
  dispatchOnMount: () => ({ event: 'Error View Shown' }),
})(ErrorView);
